"use strict";
exports.__esModule = true;
var core_1 = require("@angular/core");
var core_2 = require("@ngx-translate/core");
var utils_1 = require("../utils");
var FooterComponent = /** @class */ (function () {
    function FooterComponent(translate) {
        this.translate = translate;
        this.currentYear = (new Date()).getFullYear();
        this.termsOfUseLink = '';
        this.privacyLink = '';
    }
    FooterComponent.prototype.ngOnInit = function () {
        var _this = this;
        utils_1.Utils.setUnusualBrowserSettings();
        this.setTermsOfUseLink();
        this.setPrivacyLink();
        this.translate.onLangChange.subscribe(function () {
            _this.setTermsOfUseLink();
            _this.setPrivacyLink();
        });
    };
    FooterComponent.prototype.setTermsOfUseLink = function () {
        var _this = this;
        this.translate.get('FOOTER.TERMS_OF_USE_LINK').subscribe(function (link) {
            _this.termsOfUseLink = link;
        });
    };
    FooterComponent.prototype.setPrivacyLink = function () {
        var _this = this;
        this.translate.get('FOOTER.PRIVACY_LINK').subscribe(function (link) {
            _this.privacyLink = link;
        });
    };
    return FooterComponent;
}());
exports.FooterComponent = FooterComponent;
